<template>
  <div class="supplier-price-container">
    <div class="t-top-bar">
      <el-input placeholder="请输入内容" v-model="listQuery.keyword" class="input-with-select search-input">
        <el-button  slot="append"  type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
      </el-input>

      <div class="btns">
        <a title="导入模板下载" href="/supplierPriceImport.xlsx" download="供应商计价导入模板">导入模板下载</a>
        <el-upload style="margin-left: 15px" v-if="authedCheck('供应商计价导入')" title="供应商计价导入"
                   class="upload-demo" :data="uploadParam"
                   :action="uploadUrl" :show-file-list="false"
                   :multiple="false" :on-success="uploadHandler" :on-progress="uploadProgressHandler">
          <el-button type="primary">导入</el-button>
        </el-upload>
        <el-button style="margin-left: 15px" type="primary" v-if="authedCheck('添加供料价格')" title="添加供料价格" @click="addHandler">添加</el-button>
      </div>
    </div>
    <el-table :data="tableData" border style="width: 100%" v-loading="listLoading">
      <el-table-column prop="priceId" label="规则编号" width="100"></el-table-column>
      <el-table-column prop="priceName" label="规则名称"></el-table-column>
      <el-table-column prop="useType" label="计价类型">
        <template slot-scope="scope">
          {{scope.row.useType == 0?'统一计价':'差异计价'}}
        </template>
      </el-table-column>
      <el-table-column prop="price" label="单价(元)"></el-table-column>
      <el-table-column prop="append" label="备注"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <i class="el-icon-edit el-icon-table btn-primary" v-if="authedCheck('编辑供料价格')" title="编辑供料价格"
             @click="editHandler(scope.row)"></i>
          <i class="el-icon-notebook-1 el-icon-table btn-warning" @click="hisHandler(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>


    <el-dialog :title="opFlag=='add'?'添加计价规则':'修改计价规则'" :visible.sync="addDialogVisiable" @close="addCloseHandler" width="650px">
      <el-form :model="addForm" :rules="rules" ref="addForm">
        <el-form-item label="规则名称" :label-width="formLabelWidth">
          <el-input disabled="disabled" v-model="priceName" autocomplete="off"></el-input>
        </el-form-item>
<!--        <el-form-item label="供应商" prop="supplierId" :label-width="formLabelWidth">-->
<!--          <el-select :disabled="opFlag=='edit'" v-model="addForm.supplierId" placeholder="请选供应商">-->
<!--            <el-option v-for="(val,key) in supplierList" :key="key" :label="val.supplierName" :value="val.supplierId"></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="计价类型" prop="useType" :label-width="formLabelWidth">
          <el-select :disabled="opFlag=='edit'" v-model="addForm.useType" placeholder="计价类型">
            <el-option label="统一计价" value="0"></el-option>
            <el-option label="差异计价" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品" prop="productionId" :label-width="formLabelWidth">
            <el-select :disabled="opFlag=='edit'" v-model="addForm.productionId" placeholder="请选产品">
                <el-option v-for="(val,key) in products" :key="key" :label="val.productionName" :value="val.productionId"></el-option>
            </el-select>
        </el-form-item>
          <el-form-item label="规格" prop="specId" :label-width="formLabelWidth">
              <el-select :disabled="opFlag=='edit'" v-model="addForm.specId" placeholder="请选规格">
                  <el-option v-for="(val,key) in specs[addForm.productionId]" :key="key" :label="val.specName" :value="val.specId"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="单价(元)" prop="price" :label-width="formLabelWidth">
              <el-input type="number" v-model="addForm.price" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="append" :label-width="formLabelWidth">
            <el-input v-model="addForm.append" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item v-if="opFlag=='edit'" label="修改记录" prop="changeRecord" :label-width="formLabelWidth">
            <el-select v-model="addForm.changeRecord" placeholder="请选则是否修改记录">
              <el-option  label="不修改" value="1"></el-option>
              <el-option  label="修改" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="addForm.changeRecord==2" label="供应商" prop="changeSupplierId" :label-width="formLabelWidth">
            <el-select multiple filterable  collapse-tags  v-model="addForm.changeSupplierId" placeholder="请选供应商">
              <el-option v-for="(val,key) in supplierList" :key="key" :label="val.supplierName" :value="val.supplierId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="addForm.changeRecord==2" label="开始时间" prop="changeBeginTime" :label-width="formLabelWidth">
            <el-date-picker v-model="addForm.changeBeginTime" type="datetime"  placeholder="开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item v-if="addForm.changeRecord==2" label="结束时间" prop="changeEndTime" :label-width="formLabelWidth">
            <el-date-picker v-model="addForm.changeEndTime" type="datetime" placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisiable = false">取 消</el-button>
        <el-button type="primary" @click="addConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="历史记录" :visible.sync="hisDialogVisiable" width="1150px">
        <el-table :data="hisTableData" border style="width: 100%" v-loading="hisListLoading">
            <el-table-column prop="priceId" label="规则编号" width="100"></el-table-column>
            <el-table-column prop="priceName" label="规则名称">
                <template slot-scope="scope">
                    {{createPriceName(scope.row)}}
                </template>
            </el-table-column>
            <el-table-column prop="activeTime" label="生效时间" width="180">
                <template slot-scope="scope">
                    {{scope.row.activeTime | formateTime}}
                </template>
            </el-table-column>
            <el-table-column prop="reactiveTime" label="失效时间" width="180">
                <template slot-scope="scope">
                    {{scope.row.reactiveTime | formateTime}}
                </template>
            </el-table-column>
        </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="hisDialogVisiable = false">取 消</el-button>
        <el-button type="primary" @click="hisDialogVisiable=false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    import { getSupplierList } from '@/api/supplier'
    import { addPrice,updatePrice,getPriceList,getHisPriceList } from '@/api/supplierPrice'
    import { getProductionVoList } from '@/api/prouction'
    import { getShiftList } from '@/api/shift'
    import localCache from "@/util/localCache";
    export default {
        name: "supplierPrice",
        data() {
            let reg = /^\d{0,5}\.?\d{0,2}$/
            let checkPrice = (rule, value, callback) => {
                if(value === ''){
                    callback(new Error('请输入数字值'));
                }
                console.log(value)
                if (!reg.test(''+value)) {
                    callback(new Error('请输入数字值'));
                } else {
                    if (value < 0 || value > 99999) {
                        callback(new Error('数值范围0-99999'));
                    } else {
                        callback();
                    }
                }
            }
            return {
                addDialogVisiable: false,
                hisDialogVisiable: false,
                opFlag: 'add',
                confirmVisible: false,
                formLabelWidth: '120px',
                tableData: [],
                hisTableData:[],
                addForm: {
                    productionId:'',
                    specId:'',
                    supplierId:'',
                    price:0,
                  append: '',
                  changeRecord: '1',
                  changeSupplierId: '',
                  changeBeginTime: '',
                  changeEndTime: ''
                },
                rules: {
                  changeBeginTime: [
                    { required: true, message: '请选择开始时间', trigger: 'blur' },
                  ],
                  changeEndTime: [
                    { required: true, message: '请选择结束时间', trigger: 'blur' },
                  ],
                    productionId: [
                        { required: true, message: '请选择产品', trigger: 'blur' },
                    ],
                    price: [
                        { required: true,validator: checkPrice, trigger: 'blur' }
                    ]
                },
                listQuery: {
                    keyword: ''
                },
                listLoading: true,
                hisListLoading:false,
                selectRow: '',
                products:[],
                specs:{},
                technologs:{},
                shifts:[],
                supplierList:[],
                uploadLoading: '',
                uploadUrl: process.env.VUE_APP_BASE_API+'/fileupload',
                uploadParam:{
                  type: 5
                },
            }
        },
        mounted(){
          this.uploadParam.customerId = localCache.getCurrentCustomerId()
          this.uploadParam.token = localCache.getToken()
            this.getList()
            this.getProductionVoList_()
        },
        computed:{
            priceName(){
                let str = ''

                // if(this.addForm.supplierId){
                //   str += this.getTargetValue(this.supplierList,this.addForm.supplierId,'supplierId','supplierName')
                // }
               let pid = this.addForm.productionId
                if(pid){
                    str += this.getTargetValue(this.products,pid,'productionId','productionName')
                }
                if(this.addForm.specId){
                    str += '/'+this.getTargetValue(this.specs[pid],this.addForm.specId,'specId','specName')
                }

                return str
            }
        },
        methods: {
          getSupplierList_(){
            let param = {
              customerId: localCache.getCurrentCustomerId(),
            }
            getSupplierList(param).then(res => {
              if (res.errorcode !== 0) {
                this.$message.error(res.message)
              } else {
                this.supplierList = res.data
              }
            }).catch(() => {
            })
          },
            getTargetValue(obj,val, equalKey,targetkey){
                for (let i = 0,len=obj.length; i < len; i++) {
                    if(val == obj[i][equalKey]){
                        return obj[i][targetkey]
                    }
                }
            },
            createPriceName(row){
              let name = row.productionName;
              if(row.specName){
                  name += "-"+row.specName
              }
                if(row.technologyName){
                    name += "-"+row.technologyName
                }
                return name || '--'
            },
            getProductionVoList_(){
                getProductionVoList({
                    customerId: localCache.getCurrentCustomerId()
                }).then(res => {
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.products = res.data
                        let data = this.products
                        for (let i = 0, len = this.products.length; i < len; i++) {
                            let pid = data[i].productionId
                            this.specs[pid] = data[i].specs
                            this.technologs[pid] = data[i].technologies
                        }
                    }
                }).catch(() => {
                })
            },
            addCloseHandler(){
                this.$refs['addForm'].resetFields()
                this.addForm =  {
                    staffType:'',
                    shiftId:'',
                    productionId:'',
                    specId:'',
                    technologyId:'',
                    price:0,
                  append: '',
                  changeSupplierId: '',
                  changeBeginTime: '',
                  changeEndTime: ''
                }
                this.opFlag='add'
            },
            addHandler() {
                this.opFlag='add'
                this.addDialogVisiable = true
            },
            editHandler(row) {
                this.selectRow = row
                this.opFlag='edit'
                this.addForm = Object.assign({}, row)
                this.addDialogVisiable = true
                this.getSupplierList_()
            },
            addConfirm() {
                this.$refs['addForm'].validate((valid) => {
                    if (!valid) {
                        return
                    }
                    let param = Object.assign({}, this.addForm)
                    if(this.opFlag == 'add'){

                    }else if(this.opFlag == 'edit'){
                        param.priceId = this.selectRow.priceId
                    }
                    param.customerId = localCache.getCurrentCustomerId()
                    param.priceType=4
                    param.priceName = this.priceName
                    if(this.opFlag=='add'){
                        addPrice(param).then((res)=>{
                            if(res.errorcode==0){
                                this.$message.success('添加成功')
                                this.addDialogVisiable = false
                                this.getList()
                            }else{
                                this.$message.error(res.message)
                            }
                        })
                    }else{
                        if(param.changeRecord == 2){
                          param.changeBeginTime = new Date(param.changeBeginTime).getTime()/1000
                          param.changeEndTime = new Date(param.changeEndTime).getTime()/1000
                          param.changeSupplierId = param.changeSupplierId.join(',')
                        }
                        updatePrice(param).then((res)=>{
                            if(res.errorcode==0){
                                this.$message({
                                    message: '修改成功',
                                    type: 'success'
                                })
                                this.addDialogVisiable = false
                                this.getList()
                            }else{
                                this.$message.success(res.message)
                            }
                        })
                    }
                });
            },
            getList() {
                this.listLoading = true
                this.listQuery.customerId = localCache.getCurrentCustomerId()
                getPriceList(this.listQuery).then(res => {
                    this.listLoading = false
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.tableData = res.data
                    }
                }).catch(() => {
                    this.listLoading = false
                })
            },

            hisHandler(row){
                this.selectRow = row
                this.hisDialogVisiable = true
                this.hisListLoading = true

                getHisPriceList({
                    priceId:row.priceId,
                    customerId: localCache.getCurrentCustomerId()
                }).then(res => {
                    this.hisListLoading = false
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.hisTableData = res.data
                    }
                }).catch(() => {
                    this.hisListLoading = false
                })
            },
          uploadHandler(res, file, fileList){
            if (res.errorcode !== 0) {
              this.$message.error(res.message)
            } else {
              this.$message.success('导入成功')
              this.getList()
            }
            this.uploadLoading.close()
          },
          uploadProgressHandler(event, file, fileList){
            this.uploadLoading = this.$loading({
              lock: true,
              text: '导入中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
          },
        }
    }
</script>

<style lang="scss">
.supplier-price-container{
  .t-top-bar{
    margin-bottom: 15px;
    .btns{
      float: right;
      display: flex;
      align-items: center;
      width: 260px;
      justify-content: flex-end;
    }
  }
  .search-input {
    width: 350px;
  }
  .l-add-buttion{
    font-size: 35px;
    float: right;
    cursor: pointer;
  }
}
</style>
